module.exports = __webpack_public_path__ + "static/media/barber1.7a517916.jpg";